/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Back_To_DashboardInputs */

const en_users_back_to_dashboard = /** @type {(inputs: Users_Back_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Back to dashboard`)
};

const pt_br2_users_back_to_dashboard = /** @type {(inputs: Users_Back_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Voltar ao painel`)
};

/**
* | output |
* | --- |
* | "← Back to dashboard" |
*
* @param {Users_Back_To_DashboardInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_back_to_dashboard = /** @type {((inputs?: Users_Back_To_DashboardInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Back_To_DashboardInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_back_to_dashboard(inputs)
	return pt_br2_users_back_to_dashboard(inputs)
});